import React from "react";
import moment from "moment";
import { Col, Form, Row, InputGroup } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";

const today = moment().format("YYYY-MM-DD");

export default function DaterangeSelector({
  from = today,
  to = today,
  startDate = today,
  endDate = today,
  handleChange = (f) => f,
  onChange = (f) => f,
  className = "",
  size = "md"
}) {
  // Support both old and new API
  const fromDate = startDate || from;
  const toDate = endDate || to;
  
  const handleDateChange = (e) => {
    const { name, value } = e.target;
    
    // Support old API
    if (handleChange && handleChange !== ((f) => f)) {
      handleChange(e);
    }
    
    // Support new API
    if (onChange && onChange !== ((f) => f)) {
      if (name === "from" || name === "startDate") {
        onChange(value, toDate);
      } else if (name === "to" || name === "endDate") {
        onChange(fromDate, value);
      }
    }
  };

  return (
    <Row className={`align-items-end ${className}`}>
      <Col md={6}>
        <Form.Group className="mb-0">
          <Form.Label className="fw-bold small">From Date</Form.Label>
          <InputGroup size={size}>
            <InputGroup.Text>
              <FontAwesomeIcon icon={faCalendarAlt} />
            </InputGroup.Text>
            <Form.Control
              type="date"
              value={fromDate}
              name="from"
              onChange={handleDateChange}
            />
          </InputGroup>
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group className="mb-0">
          <Form.Label className="fw-bold small">To Date</Form.Label>
          <InputGroup size={size}>
            <InputGroup.Text>
              <FontAwesomeIcon icon={faCalendarAlt} />
            </InputGroup.Text>
            <Form.Control
              type="date"
              value={toDate}
              name="to"
              onChange={handleDateChange}
            />
          </InputGroup>
        </Form.Group>
      </Col>
    </Row>
  );
}
